import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Container, Row, Col, Card } from 'react-bootstrap';

import { getContentBlockItemsByName, getContentBlockItemValue } from '../../../Cms/CmsActions.js';
import { getUserGroup, USER_GROUP_DEFAULT } from '../../../User/UserGroupActions.js';

import AppLogo from '../../../App/components/view/AppLogo.js';
import HtmlComponent from '../../../../components/Text/HtmlComponent.js';
import CmsPanel from '../../../Cms/components/content/CmsPanel.js';

function PanelCategories({ panel, userGroup = null, locale }) {
    const { blocks } = panel || {};
    const panels = getContentBlockItemsByName(blocks, 'panels');
    const content = getContentBlockItemValue(blocks, 'content');

    if(panels && panels.length > 0) {
        const hasFillerCell = panels.length % 3 !== 0;
        return (
            <div className="bg-white">
                <Container>
                    <div className="mb-3 text-center">
                        <span className="d-block mb-2 text-uppercase fw-bold text-danger small" style={{ letterSpacing: '0.1em' }}><FormattedMessage id="appIntroText3" defaultMessage="Our selection" /></span>
                    </div>
                    <Row className="g-1 g-md-3 g-lg-4">
                        {panels.map((item, index) => (
                            <Col key={item.text || index} xs="12" sm="6" lg={panels.length % 3 === 0 ? 4 : 6}>
                                <CmsPanel slug={item.text} locale={locale} />
                            </Col>
                        ))}
                        {/* {hasFillerCell && (
                            <Col xs="12" sm="6" lg="4" className={classnames(!content && ['d-none', 'd-md-block'])}>
                                {
                                    content && ((userGroup || {}).identifier === USER_GROUP_DEFAULT)
                                        ? (
                                            <Card body className="h-100 shadow-sm border text-center d-flex align-items-center justify-content-center">
                                                <HtmlComponent text={content} />
                                            </Card>
                                        ) : (
                                            <AppLogo suffix="D-fade" className="mw-100 card-image" loading="lazy" />
                                        )
                                }
                            </Col>
                        )} */}
                    </Row>
                </Container>
            </div>
        );
    }
    return null;
}

function mapStateToProps(store) {
    return {
        userGroup: getUserGroup(store),
        locale: store.intl.locale,
    };
}

PanelCategories.propTypes = {
    panel: PropTypes.object.isRequired,
    userGroup: PropTypes.object,
    locale: PropTypes.string.isRequired,
};

export default connect(mapStateToProps)(PanelCategories);
